// eslint-disable-next-line import/prefer-default-export
export const downloadCSVWithResponseBlob = (fileHeaderName, data) => {
  const today = new Date().toLocaleDateString('en-GB').split('/').join('-')
  const fileName = `${fileHeaderName}-${today}.csv`
  const downloadUrl = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement('a')

  link.href = downloadUrl
  link.setAttribute('download', fileName) // any other extension
  document.body.appendChild(link)
  link.click()
  link.remove()
}

// eslint-disable-next-line import/prefer-default-export
export const useGetUserMarketAndRole = (oktaGroups) => {
  const cleanGroups = {}

  oktaGroups.forEach((group) => {
    const type = group.includes('-market_') ? 'market' : 'role'
    const cleanGroupText = group.replace(/.+?(-role_)/, '').replace('_', ' ')
    const value = cleanGroupText.split(' ').map((val) => val.charAt(0).toUpperCase() + val.substring(1).toLowerCase()).join(' ')

    cleanGroups[type] = value
  })
  return cleanGroups
}
